import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MapPreference } from "shared/constants/organization.const";
import { logWarningForMissingTranslation } from "utils/log-warning.utils";

export const useMapPreferenceOptionsTranslation = () => {
  const { t } = useTranslation("component");

  const getTranslatedOption = useCallback(
    (option: string) => {
      switch (option) {
        case MapPreference.CONNECTED_CAR:
          return t("component:Connected Car");
        case MapPreference.ORIGIN_AND_DESTINATION:
          return t("component:Origin & Destination");
        case MapPreference.MILESTONES:
          return t("component:Milestones");
        case MapPreference.SHIPMENT_COORDINATES:
          return t("component:Shipment Coordinates");
        default: {
          logWarningForMissingTranslation(option);
          return option;
        }
      }
    },
    [t],
  );

  return { getTranslatedOption };
};
